import React from 'react'
import glamorous from 'glamorous'
import Tooltip from 'antd/lib/tooltip'
import Button from 'antd/lib/button'
import { Table, Radio, Popconfirm, Input } from 'antd';
import Modal from 'antd/lib/modal'
import Row from 'antd/lib/row'
import Col from 'antd/lib/col'
import message from 'antd/lib/message'
import get from 'lodash/fp/get'
import flow from 'lodash/fp/flow'
import pick from 'lodash/fp/pick'
import { V2_SR_TABLEWISE_SUMMARY_QUERY, CompanyByIdQuery } from 'qgst-gql-queries/web/data.json'
import { gql, graphql, compose } from 'react-apollo'
import { connect } from 'react-redux'
import DropZone from 'react-dropzone';
import { Root, ContentWrapper as Content } from '../../shared/styles'
import SALES from '../../services/Anx1SalesService'
import { BASE_URL } from '../../shared/constants'
import { gspActions } from "../../gspRedux";
import toString from "lodash/fp/toString";
import Column from 'antd/lib/table/Column';
import ANX1B2BA from './ANX1B2BA';
import ANX1B2C from './ANX1B2C';
import ANX1B2B from './ANX1B2B';
import ANX1EXP from './ANX1EXP';
import ANX1SEZ from './ANX1SEZ';
import ANX1DE from './ANX1DE';
import ANX1REV from './ANX1REV';
import ANX1IMPS from './ANX1IMPS';
import ANX1IMPG from './ANX1IMPG';
import ANX1IMPGSEZ from './ANX1IMPGSEZ';
import ANX1ECOM from './ANX1ECOM';
import ANX1MissingDocs from './ANX1MissingDocs'
import ANX1DEA from './ANX1DEA'
import ANX1SEZWPA from './ANX1SEZWPA'
import ANX1SEZWOPA from './ANX1SEZWOPA'
import './Anx1Buttons.css';
var comp_id = '...'
const SRow = glamorous(Row)({ margin: '15px 0', })
const confirm = Modal.confirm;
const errorModal = Modal.error;
// change
const Anx1Register = props => {
    return (
        <Root >
            <Content >
            <Row
      gutter={[16, 16]}
      className="anx1-btn"
      style={{
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        ...props.row_style, // Merge with provided row_style, if any
      }}
    >
      {/* Download Button */}
      {/* <Col xs={24} sm={12} md={8} lg={5} xl={5}>
        <Tooltip title="Download ANX1 Data" placement="top">
          <Button
            className="anx1-upload-btn ant-btn-primary"
            size="large"
            id="sales_download"
          >
            <div>
              <p style={{ textAlign: 'center' }}>Download</p>
              <p style={{ textAlign: 'center', color: '#298AB7' }}>ANX1</p>
            </div>
          </Button>
        </Tooltip>
      </Col> */}

      {/* Confirm Upload Button */}
      {/* <Col xs={24} sm={12} md={8} lg={5} xl={5}>
        <Tooltip title="Confirm Upload" placement="top">
          <Button
            className="anx1-upload-btn"
            size="large"
            id="sales_confirm_upload"
            onClick={props.showUploadConfirm}
          >
            <div>
              <p style={{ textAlign: 'center' }}>Confirm</p>
              <p style={{ textAlign: 'center', color: '#298AB7' }}>Upload</p>
            </div>
          </Button>
        </Tooltip>
      </Col> */}

      {/* Upload ANX1 */}
      {!props.externalInterfaceInfo && (
        <Col xs={24} sm={12} md={8} lg={5} xl={5} className="ax1_col_1">
          <DropZone
            onDrop={props.onDropAnx1}
            multiple={false}
            disabled={props.role === 'reviewer'}
          >
            {({ getRootProps, getInputProps }) => (
              <div {...getRootProps()}>
                <input {...getInputProps()} />
                <Tooltip title="Upload ANX1" placement="top">
                  <Button
                    style={{gap:"8%"}}
                    className="anx1-upload-btn"
                    size="large"
                    icon="cloud-upload"
                    disabled={props.role === 'reviewer'}
                  >
                    <div>
                      <p style={{ textAlign: 'center' }}>Upload</p>
                      <p style={{ textAlign: 'center', color: '#298AB7' }}>ANX1</p>
                    </div>
                  </Button>
                </Tooltip>
              </div>
            )}
          </DropZone>
        </Col>
      )}

      {/* Sync with GSTN */}
      <Col xs={24} sm={12} md={8} lg={5} xl={5} className="ax1_col_2">
        <Tooltip title="Synchronize With GSTN" placement="top">
          <Button
           style={{gap:"8%"}}
            className="anx1-upload-btn"
            size="large"
            icon="sync"
            onClick={props.syncAnx1}
          >
            <div>
              <p style={{ textAlign: 'center' }}>Sync with</p>
              <p style={{ textAlign: 'center', color: '#298AB7' }}>GSTN</p>
            </div>
          </Button>
        </Tooltip>
      </Col>

      {/* Reset Button */}
      <Col xs={24} sm={12} md={8} lg={5} xl={5} className="anx1_rest ax1_col_3">
        <Tooltip title="Clear all Sales for selected Tax Period" placement="top">
          <Popconfirm
            placement="bottomRight"
            title="Clicking this button will reset all Sales for selected Tax Period!"
            onVisibleChange={props.popupConfirmResetVisibleChange}
            visible={props.popupConfirmReset}
            onConfirm={props.resetSales}
            okText="Yes"
            cancelText="No"
          >
            <Button
             style={{gap:"8%"}}
              className="anx1-reset-btn"
              size="large"
              disabled={props.role === 'reviewer'}
            >
              <svg
                width="27"
                height="39"
                viewBox="0 0 23 21"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
                style={{ marginRight: '8px' }}
              >
                <path
                  d="M3.2619 10.5C3.2619 12.5449 3.92175 14.5353 5.14338 16.1752C6.365 17.8151 8.08318 19.0171 10.0425 19.6025C12.0019 20.1878 14.0979 20.1253 16.0189 19.4243C17.9399 18.7232 19.5834 17.421 20.7051 15.7111C21.8268 14.0013 22.3669 11.9752 22.245 9.93389C22.1232 7.89259 21.3459 5.9451 20.0287 4.38088C18.7115 2.81666 16.9248 1.71921 14.934 1.25165C12.9432 0.784095 10.8547 0.971388 8.97894 1.78569"
                  stroke="#595959"
                  strokeWidth="1.3"
                  strokeLinecap="round"
                />
                <path
                  d="M1 12.7619L2.94181 10.4317C3.11859 10.2196 3.43388 10.1909 3.64602 10.3677L5.97619 12.3095"
                  stroke="#595959"
                  strokeWidth="1.3"
                  strokeLinecap="round"
                />
              </svg>
              Reset
            </Button>
          </Popconfirm>
        </Tooltip>
      </Col>
    </Row>
                <Row>
                    <Table pagination={false} dataSource={props.v2_sr_tablewise_summary ? get('viewer.v2_sr_tablewise_summary.edges')(props.v2_sr_tablewise_summary) : []} bordered title={() => 'Table Wise Summary'}>
                        <Column title="Category" dataIndex='category' key="category"
                            render={(text, record) => {
                                if (record.category != "Total Outward Supplies" && record.category != "Total Net Liability") {
                                    return (record.category)
                                }
                                else {
                                    return (<strong>{record.category}</strong>)
                                }
                            }}

                        ></Column>
                        <Column title={"Number of Records"} dataIndex='records' align='center'
                            key="records" render={(text, record) => {
                                return ((record.category != "Total Outward Supplies" && record.category != "Total Net Liability") ?
                                    <Button size="large" id={record.category} style={{ width: "3em", fontSize: '14px', padding: '0 10px', backgroundColor: '#CEDDE5', color: '#09537C' }}
                                        onClick={props.showModal}
                                    >
                                        {text}
                                    </Button> :
                                    <strong>{text}</strong>
                                )
                            }}
                        ></Column>
                        <Column title="Invoice Value" dataIndex='invoiceValue' align='right'
                            key="invoiceValue" render={(text, record) => {
                                if (record.category != "Total Outward Supplies" && record.category != "Total Net Liability") {
                                    return (<span>{text}</span>)
                                }
                                else {
                                    return (<strong>{text}</strong>)
                                }

                            }}
                        ></Column>
                        <Column title="Taxable Value" dataIndex='taxableValue' align='right'
                            key="taxableVAlue" render={(text, record) => {
                                if (record.category != "ECOM" && record.category != "Total Outward Supplies" && record.category != "Total Net Liability") {
                                    return (<div>{text}</div>)
                                }
                                else if (record.category != "Total Outward Supplies" && record.category != "Total Net Liability") {
                                    return {
                                        props: {
                                            style: { background: "#d9d9d9" }
                                        },
                                        children: <span></span>
                                    }
                                }
                                else {
                                    return (<strong>{text}</strong>)
                                }
                            }}
                        ></Column>
                        <Column title="Integrated Tax" dataIndex="igst" align='right'
                            key="igst" render={(text, record) => {
                                if (record.category != "SEZWOP-A" && record.category != "Total Outward Supplies" && record.category != "Total Net Liability") {
                                    return (<div>{text}</div>)
                                }
                                else if (record.category != "Total Outward Supplies" && record.category != "Total Net Liability") {
                                    return {
                                        props: {
                                            style: { background: "#d9d9d9" }
                                        },
                                        children: (<span></span>)
                                    }
                                }
                                else {
                                    return (<strong>{text}</strong>)
                                }
                            }}
                        ></Column>
                        <Column title="Central Tax" dataIndex="cgst" align='right'
                            key="cgst" render={(text, record) => {
                                if (record.category != "EXP" && record.category != "SEZ" && record.category != "IMPS" && record.category != "IMPG" && record.category != "IMPGSEZ" && record.category != "SEZWP-A" && record.category != "SEZWOP-A" && record.category != "Total Outward Supplies" && record.category != "Total Net Liability") {
                                    return (<div>{text}</div>)
                                }
                                else if (record.category != "Total Outward Supplies" && record.category != "Total Net Liability") {
                                    return {
                                        props: {
                                            style: { background: "#d9d9d9" }
                                        },
                                        children: (<span></span>)
                                    }
                                }
                                else {
                                    return (<strong>{text}</strong>)
                                }
                            }
                            }
                        >
                        </Column>
                        <Column title="State Tax" dataIndex="sgst" align='right'
                            key="sgst" render={(text, record) => {
                                if (record.category != "EXP" && record.category != "SEZ" && record.category != "IMPS" && record.category != "IMPG" && record.category != "IMPGSEZ" && record.category != "SEZWP-A" && record.category != "SEZWOP-A" && record.category != "Total Outward Supplies" && record.category != "Total Net Liability") {
                                    return (<div>{text}</div>)
                                }
                                else if (record.category != "Total Outward Supplies" && record.category != "Total Net Liability") {
                                    return {
                                        props: {
                                            style: { background: "#d9d9d9" }
                                        },
                                        children: (<span></span>)
                                    }
                                }
                                else {
                                    return (<strong>{text}</strong>)
                                }
                            }
                            }
                        ></Column>
                        <Column title="Cess" dataIndex="cess" align='right'
                            key="cess" render={(text, record) => {
                                if (record.category != "SEZWOP-A" && record.category != "Total Outward Supplies" && record.category != "Total Net Liability") {
                                    return (<div>{text}</div>)
                                }
                                else if (record.category != "Total Outward Supplies" && record.category != "Total Net Liability") {
                                    return {
                                        props: {
                                            style: { background: "#d9d9d9" }
                                        },
                                        children: (<span></span>)
                                    }
                                }
                                else {
                                    return (<strong>{text}</strong>)
                                }
                            }}
                        ></Column>
                    </Table>
                </Row>
                <Modal
                    centered
                    width={"90%"}
                    visible={props.summary_modal_visible}
                    onCancel={props.handleCancel}
                    footer={<Button onClick={props.handleCancel}
                        style={{ width: "5em", fontSize: '14px', padding: '0 10px', backgroundColor: '#09537C', color: 'white' }} >
                        OK
                        </Button>}
                >
                    {props.summary_modal_source === "b2c" && <ANX1B2C />}
                    {props.summary_modal_source === "b2b" && <ANX1B2B />}
                    {props.summary_modal_source === "exp" && <ANX1EXP />}
                    {props.summary_modal_source === "sez" && <ANX1SEZ />}
                    {props.summary_modal_source === "de" && <ANX1DE />}
                    {props.summary_modal_source === "rcm" && <ANX1REV />}
                    {props.summary_modal_source === "imps" && <ANX1IMPS />}
                    {props.summary_modal_source === "impg" && <ANX1IMPG />}
                    {props.summary_modal_source === "impgsez" && <ANX1IMPGSEZ />}
                    {props.summary_modal_source === "ecom" && <ANX1ECOM />}
                    {props.summary_modal_source === "missing docs" && <ANX1MissingDocs />}
                    {props.summary_modal_source === "b2b-a" && <ANX1B2BA />}
                    {props.summary_modal_source === "de-a" && <ANX1DEA />}
                    {props.summary_modal_source === "sezwp-a" && <ANX1SEZWPA />}
                    {props.summary_modal_source === "sezwop-a" && <ANX1SEZWOPA />}
                </Modal>
            </Content>
        </Root >
    )
}

class Anx1DashboardContainer extends React.Component {

    constructor(props) {
        super(props);
        var d = new Date();
        var n = d.getMonth();
        var y = d.getYear();
        var curyear = 1900 + y;
        var nextyear = curyear + 1 - 2000;
        var year = curyear + '-' + nextyear;
        if (props.gspDetails !== undefined && props.gspDetails !== null) {
            this.gsp = {
                access_token: props.gspDetails.gspToken,
                otp: props.gspDetails.otp,
                response: null,
                response_delete: null,
            };
        } else {
            this.gsp = {};
        }

        message.config({
            maxCount: 1,
        });
        this.state = {
            finMonth: props.finMonth,
            finYear: props.finYear,
            curFinMonth: n + 1,
            curFinYear: year,
            companyId: props.selectedCompany,
            resetLoading: false,
            popupConfirmReset: false,
            visible: false,
            period: null,
            selectedCategory: "tw",
            summary_modal_source: null,
            summary_modal_visible: false
        }
        comp_id = props.selectedCompany;
        this.onCategoryChange = this.onCategoryChange.bind(this);
        this.syncAnx1 = this.syncAnx1.bind(this);
    }

    otherGSTNInformation = companyDetails => {
        const state_cd = companyDetails["gstin"].substr(0, 2);
        companyDetails["state"] = state_cd;
        return companyDetails;
    };

    showModal = (e) => {
        this.setState({ "summary_modal_source": e.target.id.toLowerCase(), "summary_modal_visible": true })
    };

    handleCancel = e => {
        this.setState({
            summary_modal_visible: false,
        });
    }
    syncAnx1 = async () => {
        var el = document.body,
            elChild = document.createElement('div');
        elChild.className = "root_div";
        elChild.innerHTML = '<div class="custom_loading loader"></div>';
        el.insertBefore(elChild, el.firstChild);
        document.getElementById('root').classList.add("blur");
        var year_trim = this.props.finYear.split("-");
        var fy = "";
        if (this.props.finMonth < 4) {
            fy = "20" + year_trim[1];
        } else {
            fy = year_trim[0];
        }
        var downloaddate = this.props.finMonth + "/" + this.props.finYear;
        var period = toString(this.props.finMonth).padStart(2, "0") + "" + fy;
        const companyDetails = flow(
            pick(["gstin", "id", "gstnUserName"]),
            this.otherGSTNInformation
        )(this.props.company);
        const postData = {
            company_id: this.props.selectedCompany,
            finYear: this.state.finYear,
            finMonth: this.state.finMonth.toString(),
            period,
            gspDetails: {
                gspToken: this.gsp.access_token,
                otp: this.gsp.otp
            },
            companyDetails
        }
        const anx1Data = await SALES.syncAnx1(postData);
        document.body.getElementsByClassName("root_div")[0].remove();
        document.getElementById('root').classList.remove('blur');

        if (anx1Data.retstatus && anx1Data.retstatus.status_cd === "P") {
            message.success('Successfully Synchronized With GSTN', 3)
            this.props.v2_sr_tablewise_summary.refetch();
        }
        else if (anx1Data.retstatus && anx1Data.retstatus.status_cd === "PE") {
            this.showConfirm(anx1Data);
            this.props.v2_sr_tablewise_summary.refetch();
        }
        else if (anx1Data.retstatus && anx1Data.retstatus.status_cd === "ER") {
            errorModal({
                title: 'Unable to process your request, Please try again later.',
            });
        }
    }
    showConfirm = (data) => {
        confirm({
            title: 'Errors Found While Syncing Anx1 with GSTN',
            iconType: 'printer',
            width: 866,
            content: (<div id="dialogue_append_sync">
                <div style={{ "width": "100%" }}>
                    <br />
                    <p>
                        <span><b style={{ "fontSize": "12px", color: "#0cde26" }}>Partially saved!</b></span>
                    </p>
                    <br />
                    <p>Click on "OK" to Download the Error Excel. Please check and correct the Errors!</p>
                </div>
            </div>),
            onOk() {
                data.downloadReport()
            }
        });
    }

    onCategoryChange = (e) => {
        this.setState({ selectedCategory: e.target.value })
    }

    showUploadConfirm() {
        confirm({
            title: 'Errors Found While Uploading Anx1',
            iconType: 'printer',
            width: 866,
            content: (<div id="dialogue_append1"></div>),
            onOk() {
                document.getElementById("sales_download").click();
                return new Promise((resolve, reject) => {
                    setTimeout(Math.random() > 0.5 ? resolve : reject, 1000);
                }).catch(() => console.log('Oops errors!'));
            }
        });
    }

    componentDidUpdate = () => {
        if (this.props.gspDetails !== undefined && this.props.gspDetails !== null) {
            this.gsp.access_token = this.props.gspDetails.gspToken;
            this.gsp.otp = (this.gsp.otp !== undefined && this.gsp.otp !== null) ? this.gsp.otp : this.props.gspDetails.otp;
        }
    };

    onRadioChange(e) {
        this.setState({ selectedOption: e.target.value });
    }

    handleVisibleChange = visible => {
        this.setState({ visible });
    };

    resetSales = () => {
        message.loading('Resetting Anx1 Sales...', 0);
        this.setState({ resetLoading: true });
        var downloaddate = this.state.finMonth + '/' + this.state.finYear;
        fetch(`${BASE_URL}/export/resetAnx1Sales?from=sales&companyId=${this.state.companyId}&downloaddate=${downloaddate}`,
            {
                method: 'GET',
            })
            .then((result) => {
                this.setState({ resetLoading: false });
                this.props.v2_sr_tablewise_summary.refetch();
                message.success('All Sales have been reset for selected tax period', 3);
            })
    }

    onDropAnx1 = async acceptedFiles => {

        var el = document.body,
            elChild = document.createElement('div');
        elChild.className = "root_div";
        elChild.innerHTML = '<div class="custom_loading loader"></div>';
        el.insertBefore(elChild, el.firstChild);
        document.getElementById('root').classList.add("blur");
        const result = await SALES.upload({
            file: acceptedFiles[0],
            type: 'sranx1',
            tally: 'true',
            companyId: this.props.selectedCompany,
            isSR: this.props.isSR,
            finMonth: this.state.finMonth,
            finYear: this.state.finYear,
        })

        document.body.getElementsByClassName("root_div")[0].remove();
        document.getElementById('root').classList.remove('blur');
        if ((result.error_status !== '') && (result.error_status !== undefined)) {
        }
        if (result.filestatus === true) {
            if (result.flag === true) {
                var dialogue_msg = '<div style="width: 20%; float:left"><img src="https://media.giphy.com/media/mh0zdNnHBV7z2/giphy.gif" / style="width:90%;border: solid 1px #d0d0d0;border-radius: 25px 0px 25px 0px;"></div ><div style="width: 80%;"><br><p><h4> ( <span><b style="font-size: 12px;color: #0cde26;">' + result.total_errors + ' Invoices Failed out of ' + result.total + ' Invoices</b></span>) Anx1 Sales Register partially saved!</h4></p><br><p>Error Excel will be downloaded. Please check and correct the Errors!</p></div>';
                var div = document.getElementById('dialogue_append1');
                if (document.getElementById('dialogue_append1') !== null) {
                    div.innerHTML += dialogue_msg;
                }
            }
            if (result.total_errors > 0) {
                this.props.v2_sr_tablewise_summary.refetch();
            }
            else {
                this.props.v2_sr_tablewise_summary.refetch();
                message.success('(' + result.total + '/' + result.total + ') Sales Invoices uploaded successfully!', 3)
            }
        } else if (result.file === false) {
            message.error('Uploaded file is not in Tally Excel format!', 3)
        } else {
            message.error('Upload File Type is Not Allowed', 3)
        }

    }

    changeSelectedFinancialMonth = name => {
        this.props.changeSelectedFinancialMonth(name)
    }

    popupConfirmResetVisibleChange = e => {
        if (!e) {
            this.setState({ popupConfirmReset: false });
            return;
        }
        if (this.props.company) {
            if (this.props.company.role === "admin") {
                this.setState({ popupConfirmReset: true })
            } else {
                this.setState({ popupConfirmReset: false })
            }
        }
    }

    render() {
        return (
            <div style={{ backgroundColor: '#fff', padding: '5px' }}>
                <Anx1Register
                    v2_sr_tablewise_summary={this.props.v2_sr_tablewise_summary}
                    role={get('company.role', this.props)}
                    finMonth={this.state.finMonth}
                    finYear={this.state.finYear}
                    showUploadConfirm={this.showUploadConfirm}
                    onSyncConfirm={this.onSyncConfirm}
                    isSR={this.props.isSR}
                    onDropAnx1={this.onDropAnx1}
                    resetSales={this.resetSales}
                    resetLoading={this.state.resetLoading}
                    popupConfirmResetVisibleChange={this.popupConfirmResetVisibleChange}
                    popupConfirmReset={this.state.popupConfirmReset}
                    externalInterfaceInfo={get('externalInterfaceInfo', this.props)}
                    selectedCategory={this.state.selectedCategory}
                    onCategoryChange={this.onCategoryChange}
                    syncAnx1={this.syncAnx1}
                    summary_modal_visible={this.state.summary_modal_visible}
                    summary_modal_source={this.state.summary_modal_source}
                    showModal={this.showModal}
                    handleCancel={this.handleCancel}
                />
            </div>
        )
    }
}

const tablewiseConfig = {
    name: "v2_sr_tablewise_summary",
    options: props => ({
        variables: {
            companyId: props.selectedCompany,
            finmonth: props.finMonth.toString(),
            finyear: props.finYear,
        },
    }),
}
const companyQueryConfig = {
    name: "company",
    options: props => ({
        variables: {
            companyId: props.selectedCompany,
            finYear: props.finYear,
            finMonth: props.finMonth,
        },
    }),
    props: ({ company }) => {
        return {
            company: get('viewer.company', company),
            gspDetails: get("viewer.gspInfo", company),
            externalInterfaceInfo: get("viewer.externalInterfaceInfo", company)
        }
    },
}

const mapStateToProps = state => {
    return {
        selectedCompany: state.local.selectedCompany,
        finMonth: state.local.finMonth,
        finYear: state.local.finYear,
        gspDetails: state.gsp
    }
}

export default compose(
    connect(mapStateToProps,
        {
            setGspToken: gspActions.setGspToken,
            setGspOtp: gspActions.setGspOtp,
            setGspDetails: gspActions.setGspDetails
        }),
    graphql(gql(V2_SR_TABLEWISE_SUMMARY_QUERY), tablewiseConfig),
    graphql(gql(CompanyByIdQuery), companyQueryConfig)
)(Anx1DashboardContainer)
